import { render, staticRenderFns } from "./VoicedAndDeafConsonants.vue?vue&type=template&id=7030ef63&lang=pug&"
import script from "./VoicedAndDeafConsonants.vue?vue&type=script&lang=js&"
export * from "./VoicedAndDeafConsonants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports